import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.xl};
`;

const PageTitle = styled.h1`
  font-size: ${props => props.theme.fontSizes.xxxl};
  color: ${props => props.theme.colors.gray[800]};
  margin: 0;
`;

const Card = styled.div`
  background: white;
  border-radius: ${props => props.theme.borders.radius.lg};
  padding: ${props => props.theme.spacing.xl};
  box-shadow: ${props => props.theme.shadows.md};
`;

const Settings = () => {
  return (
    <Container>
      <PageTitle>Settings</PageTitle>
      <Card>
        <p>System settings will be implemented here.</p>
        <p>Features will include:</p>
        <ul>
          <li>Site configuration</li>
          <li>Email settings</li>
          <li>Security settings</li>
          <li>API configurations</li>
          <li>Backup and restore</li>
          <li>System maintenance</li>
        </ul>
      </Card>
    </Container>
  );
};

export default Settings;
